



import { authService } from '@/services/AuthenticationService';
import { Paths } from '@/router';
import { Mutations } from '@/store';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class LoginCallback extends Vue {
  private async created(): Promise<void> {
    const result = await authService.handleAuthentication();
    this.$store.commit(Mutations.LOGIN, result);
    this.$router.push({ name: Paths.HOME });
  }

}
